import { render, staticRenderFns } from "./FinalizarCompra.vue?vue&type=template&id=84e179d8&scoped=true"
import script from "./FinalizarCompra.vue?vue&type=script&lang=js"
export * from "./FinalizarCompra.vue?vue&type=script&lang=js"
import style0 from "./FinalizarCompra.vue?vue&type=style&index=0&id=84e179d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e179d8",
  null
  
)

export default component.exports